import type { Locale } from "@mw/shared/i18n";

import { getRegionLocale } from "@mw/shared/i18n";

export const formatNumberToKM = (number: number) => {
  if (1000000 > number && number > 1000) {
    return `${number / 1000}k`;
  } else if (1000000 < number && number < 1000000000) {
    return `${number / 1000000}M`;
  }
  return `${number}`;
};

export const formatPrice = (number: number, currency: null | string | undefined, locale: Locale) => {
  const regionLocale = getRegionLocale(locale);
  let currencyCode = "USD";

  if (currency === "$") {
    currencyCode = "USD";
  } else if (currency === "₹") {
    currencyCode = "INR";
  } else if (currency) {
    currencyCode = currency;
  }

  const currencyFormat = new Intl.NumberFormat(regionLocale, {
    style: "currency",
    currency: currencyCode,
    currencyDisplay: "narrowSymbol",
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });
  return currencyFormat.format(number);
};
